import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { AgentListView, UpdateAgentCategory, UpdateStaffDocuments, InterviewList, UpdateInterview, SendAgentNotification } from "../../Redux/Actions/agentActions";
import { ToFirstCapital } from "../../Utils/helpers";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import "./viewAgent.css";

const ViewAgent = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const agentState = useSelector((state) => state.agents || {});
    // const documentList = agentState.agentView?.data?.document_list || [];

    const [status, setStatus] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [cancelReason, setCancelReason] = useState('');

    const [documentVerifications, setDocumentVerifications] = useState({});
    const [hasDocumentChanges, setHasDocumentChanges] = useState(false);

    const [showRejectModal, setShowRejectModal] = useState(false);
    const [selectedDocumentForReject, setSelectedDocumentForReject] = useState(null);
    const [rejectReason, setRejectReason] = useState("");

    const [showAllInterviews, setShowAllInterviews] = useState(false);
    const [selectedInterview, setSelectedInterview] = useState(null);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [newInterviewStatus, setNewInterviewStatus] = useState("");
    const [isUpdatingInterview, setIsUpdatingInterview] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [isUpdatingCategory, setIsUpdatingCategory] = useState(false);

    // Reschedule fields
    const [meetingDate, setMeetingDate] = useState("");
    const [selectedSlot, setSelectedSlot] = useState("");
    const [meetingLink, setMeetingLink] = useState("");
    const [timezone, setTimezone] = useState("Asia/Kolkata");

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

    const timeSlots = [
        { id: "1", time: "09:00 - 09:30", available: true },
        { id: "2", time: "09:30 - 10:00", available: true },
        { id: "3", time: "10:00 - 10:30", available: true },
        { id: "4", time: "10:30 - 11:00", available: true },
        { id: "5", time: "11:00 - 11:30", available: true },
        { id: "6", time: "11:30 - 12:00", available: true },
        { id: "7", time: "12:00 - 12:30", available: true },
        { id: "8", time: "12:30 - 01:00", available: true },
        { id: "9", time: "01:00 - 01:30", available: true },
        { id: "10", time: "01:30 - 02:00", available: true },
        { id: "11", time: "02:00 - 02:30", available: true },
        { id: "12", time: "02:30 - 03:00", available: true },
        { id: "13", time: "03:00 - 03:30", available: true },
        { id: "14", time: "03:30 - 04:00", available: true },
        { id: "15", time: "04:00 - 04:30", available: true },
        { id: "16", time: "04:30 - 05:00", available: true },
        { id: "17", time: "05:00 - 05:30", available: true },
        { id: "18", time: "05:30 - 06:00", available: true },
        { id: "19", time: "06:00 - 06:30", available: true },
        { id: "20", time: "06:30 - 07:00", available: true },
    ];

    useEffect(() => {
        if (id) {
            dispatch(AgentListView(id));
            dispatch(InterviewList({ page: 1, limit: 10, agent_id: id, is_deleted: false }));
        } else console.warn("No agent ID found in URL");
    }, [dispatch, id]);

    useEffect(() => {
        if (agentState.agentView?.data?.account_status) {
            setStatus(agentState.agentView.data.account_status);
        }
    }, [agentState.agentView]);

    const handleUpdateCategory = async () => {
        if (!id || !selectedCategory) return;

        setIsUpdatingCategory(true);
        try {
            const payload = { category: selectedCategory };
            await dispatch(UpdateAgentCategory(id, payload)); // Use the new action
        } catch (error) {
            console.error('Error updating category:', error);
        } finally {
            setIsUpdatingCategory(false);
        }
    };


    useEffect(() => {
        if (agentState.agentView?.data?.document_list) {
            const initialVerifications = {};
            agentState.agentView.data.document_list.forEach((doc) => {
                initialVerifications[doc.id || doc._id] = doc.isVerified || false;
            });
            setDocumentVerifications(initialVerifications);
            setHasDocumentChanges(false);
        }
    }, [agentState.agentView]);

    const data = agentState.agentView?.data || {};
    const interviews = agentState.interviews?.data || [];

    const confirmStatusChange = () => {
        setIsUpdating(true);
        setShowConfirm(false);

        const agentId = data._id || data.id;

        if (agentId && selectedStatus) {
            console.log("Status update payload:", { id: agentId, account_status: selectedStatus });
            setIsUpdating(false);
        } else {
            setIsUpdating(false);
        }
    };
    useEffect(() => {
        if (agentState.agentView?.data?.category) {
            setSelectedCategory(agentState.agentView.data.category);
        }
    }, [agentState.agentView]);

    const handleOpenStatusModal = (interview) => {
        setSelectedInterview(interview);
        setNewInterviewStatus(interview.status);
        setCancelReason('');

        if (interview.meeting_date) {
            const date = new Date(interview.meeting_date);
            const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0];

            setMeetingDate(localDate);
        }
        setSelectedSlot(interview.slot?.id || "");
        setMeetingLink(interview.meeting_link || "");
        setTimezone(interview.timezone || "Asia/Kolkata");

        setShowStatusModal(true);
    };

    const handleUpdateInterviewStatus = () => {
        if (!selectedInterview || !newInterviewStatus) return;

        setIsUpdatingInterview(true);

        const interviewId = selectedInterview._id || selectedInterview.id;
        const agentId = id;

        const payload = {
            id: interviewId,
            status: newInterviewStatus
        };

        const notificationPayload = {
            agent_id: agentId,
            type_name: "INTERVIEW_STATUS_UPDATE",
            type_id: interviewId,
            type_data: {
                interview_id: selectedInterview.interview_id,
                status: newInterviewStatus,
                agent_id: agentId
            }
        };

        if (newInterviewStatus === 'cancelled') {
            if (!cancelReason?.trim()) {
                alert('Please provide reason for cancellation');
                setIsUpdatingInterview(false);
                return;
            }
            payload.reject_reason = cancelReason;

            notificationPayload.title = "Interview Cancelled ❌";
            notificationPayload.message = `Your interview (ID: ${selectedInterview.interview_id}) has been cancelled. Reason: ${cancelReason}`;

        }
        // SCHEDULED - Send notification with meeting details
        else if (newInterviewStatus === "scheduled") {
            if (!meetingDate || !selectedSlot || !meetingLink) {
                alert("Please fill all fields for scheduling");
                setIsUpdatingInterview(false);
                return;
            }

            const selectedSlotObj = timeSlots.find(slot => slot.id === selectedSlot);
            const date = new Date(meetingDate);
            const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });

            payload.meeting_date = new Date(meetingDate).toISOString();
            payload.slot = {
                id: selectedSlot,
                time: selectedSlotObj?.time || "",
                available: true
            };
            payload.day = dayName;
            payload.timezone = timezone;
            payload.meeting_link = meetingLink;

            notificationPayload.title = "Interview Scheduled 📅";
            notificationPayload.message = `Your interview is scheduled for ${formatDate(meetingDate)} at ${selectedSlotObj?.time}. Join: ${meetingLink}`;

        }

        else if (newInterviewStatus === "completed") {
            notificationPayload.title = "Interview Completed ✅";
            notificationPayload.message = `Your interview (ID: ${selectedInterview.interview_id}) has been marked as completed. Thank you!`;
        }

        dispatch(SendAgentNotification(notificationPayload));

        dispatch(UpdateInterview(payload))
            .then(() => {
                setIsUpdatingInterview(false);
                setShowStatusModal(false);
                setSelectedInterview(null);
                setNewInterviewStatus("");
                resetRescheduleFields();
                setCancelReason('');
                dispatch(InterviewList({ page: 1, limit: 10, agent_id: id, is_deleted: false }));
            })
            .catch((error) => {
                console.error("Error updating interview:", error);
                setIsUpdatingInterview(false);
            });
    };


    const resetRescheduleFields = () => {
        setMeetingDate("");
        setSelectedSlot("");
        setMeetingLink("");
        setTimezone("Asia/Kolkata");
        setCancelReason('');
    };

    const handleRejectDocument = (docId) => {
        setSelectedDocumentForReject(docId);
        setRejectReason("");
        setShowRejectModal(true);
    };

    const documentTypes = [
        { id: "passport", name: "Passport", icon: "document-text", requiresBoth: false },
        { id: "aadhar", name: "Aadhar Card", icon: "card", requiresBoth: true },
        { id: "license", name: "Driving License", icon: "car", requiresBoth: true },
        { id: "pan", name: "PAN Card", icon: "wallet", requiresBoth: false },
    ];

    const isValidDocumentType = (docId) => {
        return documentTypes.some(type => type.id === docId);
    };

    const handleDocumentVerificationToggle = (docId) => {
        if (!canEdit) return;

        setDocumentVerifications(prev => ({
            ...prev,
            [docId]: !prev[docId]
        }));
        setHasDocumentChanges(true);
    };

    const getDocumentName = (docId) => {
        const docTypes = {
            "passport": "Passport",
            "aadhar": "Aadhar Card",
            "license": "Driving License",
            "pan": "PAN Card"
        };
        return docTypes[docId] || "Document";
    };

    const handleSaveDocumentVerifications = () => {
        const staffId = data._id || data.id;

        if (!staffId) {
            console.error("No staff ID found");
            return;
        }

        const documents = Object.keys(documentVerifications).map(docId => {
            const isVerified = documentVerifications[docId];
            let status, payload;

            if (isVerified) {
                status = "approved";
                payload = {
                    id: docId,
                    isVerified: true,
                    status: status
                };

                dispatch(SendAgentNotification({
                    agent_id: id,
                    title: "Document Verified ✅",
                    message: `Your ${getDocumentName(docId)} has been successfully verified by admin.`,
                    type_name: "DOCUMENT_VERIFICATION",
                    type_id: docId,
                    type_data: {
                        document_id: docId,
                        status: "verified",
                        staff_id: staffId
                    }
                }));

            } else {
                if (docId === selectedDocumentForReject && rejectReason) {
                    status = "rejected";
                    payload = {
                        id: docId,
                        isVerified: false,
                        status: status,
                        rejectedReason: rejectReason
                    };

                    dispatch(SendAgentNotification({
                        agent_id: id,
                        title: "Document Rejected ❌",
                        message: `Your ${getDocumentName(docId)} was rejected. Reason: ${rejectReason}`,
                        type_name: "DOCUMENT_VERIFICATION",
                        type_id: docId,
                        type_data: {
                            document_id: docId,
                            status: "rejected",
                            staff_id: staffId,
                            reject_reason: rejectReason
                        }
                    }));

                    setSelectedDocumentForReject(null);
                    setRejectReason("");
                } else {
                    status = "requested";
                    payload = {
                        id: docId,
                        isVerified: false,
                        status: status
                    };
                }
            }

            return payload;
        });

        dispatch(UpdateStaffDocuments(staffId, documents))
            .then(() => {
                setHasDocumentChanges(false);
                setShowRejectModal(false);
                dispatch(AgentListView(id));
            })
            .catch((error) => {
                console.error("Error updating documents:", error);
            });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "approved":
            case "unblock":
                return "#10b981";
            case "rejected":
                return "#ef4444";
            case "requested":
                return "#f59e0b";
            default:
                return "#6b7280";
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            timeZone: 'Asia/Kolkata'
        });
    };

    const formatTimeSlot = (interview) => {
        if (interview.slot?.time) {
            return interview.slot.time;
        }
        return 'N/A';
    };

    const getInterviewStatusClass = (status) => {
        switch (status) {
            case "completed": return "completed";
            case "scheduled": return "scheduled";
            case "cancelled": return "cancelled";
            default: return "pending";
        }
    };

    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    return (
        <div className="view-agent-container-new">
            <div className="searchbar-wrapper">
                <div className="searchbar-container">
                    <SearchBar />
                </div>
            </div>

            <div className="view-agent-header back-icon margin-0 gap-10 align-center flex-container">
                <Link to="/agent">
                    <BackIcon style={{ cursor: "pointer" }} />
                </Link>
                <div className="view-agent-title-section referral-view">
                    <h3 className="view-agent-main-title">Agent Profile Details</h3>
                    <h4 className="view-agent-breadcrumb">Agent / List / View</h4>
                </div>
            </div>

            <div className={`agent-content-new ${isUpdating || agentState.updatingDocuments ? "opacity-60" : ""}`}>
                <div className="agent-profile-header">
                    <div className="agent-profile-main">
                        {data.profile_image ? (
                            <img
                                src={data.profile_image}
                                alt={data.name}
                                className="agent-avatar"
                            />
                        ) : (
                            <div className="agent-avatar-placeholder">
                                {data.name?.charAt(0) || "A"}
                            </div>
                        )}

                        <div className="agent-profile-info">
                            <h1 className="agent-name">{data.name || "No Agent Name"}</h1>
                            <div className="agent-id-badge">Agent ID: {data.staff_id || "N/A"}</div>
                        </div>
                    </div>
                    <div className="agent-status-control">
                        <label className="status-label" style={{ color: "white" }}>Agent Category</label>
                        <select
                            value={selectedCategory || data.category || 'basic'}
                            onChange={(e) => {
                                setSelectedCategory(e.target.value);
                                // Auto-save on change
                                if (id && canEdit) {
                                    const payload = { category: e.target.value };
                                    dispatch(UpdateAgentCategory(id, payload));
                                }
                            }}
                            className="category-select"
                            disabled={!canEdit || agentState.updatingCategory}
                            style={{
                                padding: '0.5rem 0.75rem',
                                border: '2px solid #e5e7eb',
                                borderRadius: '0.375rem',
                                backgroundColor: 'white',
                                color: '#374151',
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                minWidth: '120px'
                            }}
                        >
                            <option value="basic">Basic</option>
                            <option value="standard">Standard</option>
                            <option value="premium">Premium</option>
                            <option value="luxury">Luxury</option>
                        </select>
                        {agentState.updatingCategory && (
                            <span style={{ marginLeft: '0.5rem', color: '#10b981', fontSize: '0.875rem' }}>
                                Saving...
                            </span>
                        )}
                    </div>
                </div>

                <div className="agent-details-grid">
                    <div className="agent-card">
                        <h3 className="card-title">Contact Information</h3>
                        <div className="card-content">
                            <div className="info-row">
                                <span className="info-label">Email</span>
                                <span className="info-value">{data.email || "—"}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Phone</span>
                                <span className="info-value">
                                    {data.country_code && data.contact_number
                                        ? `${data.country_code} ${data.contact_number}`
                                        : "—"}
                                </span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Role</span>
                                <span className="info-value">{ToFirstCapital(data.role) || "—"}</span>
                            </div>
                            {/* <div className="info-row">
                                <span className="info-label">Profile Status</span>
                                <span className="info-value">{ToFirstCapital(data.profile_status) || "—"}</span>
                            </div> */}
                        </div>
                    </div>

                    <div className="agent-card">
                        <h3 className="card-title">Location</h3>
                        <div className="card-content">
                            <div className="info-row">
                                <span className="info-label">City</span>
                                <span className="info-value">{data.city?.city_name || "—"}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">State</span>
                                <span className="info-value">{data.state?.state_name || "—"}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Country</span>
                                <span className="info-value">{data.country?.country_name || "—"}</span>
                            </div>
                        </div>
                    </div>

                    <div className="agent-card">
                        <h3 className="card-title">Verification Status</h3>
                        <div className="card-content">
                            <div className="info-row">
                                <span className="info-label">Profile Status</span>
                                <span className="info-value">
                                    {ToFirstCapital(data.profile_status) || 'Not Set'}
                                </span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Email Verified</span>
                                <span className="info-value">
                                    {data.is_email_verified ? "✓ Verified" : "✕ Unverified"}
                                </span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Phone Verified</span>
                                <span className="info-value">
                                    {data.is_contact_number_verified ? "✓ Verified" : "✕ Unverified"}
                                </span>
                            </div>
                        </div>
                    </div>

                    {data.document_list && data.document_list.length > 0 && (
                        <div className="agent-card" style={{ gridColumn: '1 / -1' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.75rem', borderBottom: '2px solid #f0f0f0' }}>
                                <h3 className="card-title" style={{ padding: 0, margin: 0, borderBottom: 'none' }}>
                                    Documents
                                </h3>
                                {canEdit && hasDocumentChanges && (
                                    <button
                                        onClick={handleSaveDocumentVerifications}
                                        disabled={agentState.updatingDocuments}
                                        className="btn-save-documents"
                                    >
                                        {agentState.updatingDocuments ? "Saving..." : "Save Changes"}
                                    </button>
                                )}
                            </div>
                            <div className="card-content">
                                <div className="documents-grid">
                                    {data.document_list && data.document_list.length > 0 && (
                                        <div className="agent-card" style={{ gridColumn: '1 / -1' }}>
                                            {/* <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '1.75rem',
                                                borderBottom: '2px solid #f0f0f0'
                                            }}>
                                                <h3 className="card-title" style={{ padding: 0, margin: 0, borderBottom: 'none' }}>
                                                    Documents
                                                </h3>
                                                {canEdit && hasDocumentChanges && (
                                                    <button
                                                        onClick={handleSaveDocumentVerifications}
                                                        disabled={agentState.updatingDocuments}
                                                        className="btn-save-documents"
                                                    >
                                                        {agentState.updatingDocuments ? "Saving..." : "Save Changes"}
                                                    </button>
                                                )}
                                            </div> */}
                                            <div className="card-content">
                                                <div className="documents-grid">
                                                    {data.document_list.map((doc, index) => {
                                                        const docId = doc.id || doc._id;
                                                        const isVerified = documentVerifications[docId] || false;
                                                        const isValidDocType = isValidDocumentType(docId);
                                                        const isRejected = doc.status === 'rejected';

                                                        return (
                                                            <div key={index} className="document-item-card">
                                                                <div className="document-header">
                                                                    <span className="document-name">{doc.name}</span>

                                                                    <div className="document-status-actions">
                                                                        <div className={`document-status-badge ${isRejected ? 'rejected' :
                                                                            isVerified ? 'verified' :
                                                                                'requested'
                                                                            }`}>
                                                                            {isRejected ? 'Rejected' :
                                                                                isVerified ? 'Verified' :
                                                                                    (doc.status || 'Requested')}
                                                                        </div>

                                                                        {doc.status === 'requested' && !isRejected && canEdit && isValidDocType && (
                                                                            <div className="document-action-buttons">
                                                                                {!isVerified ? (
                                                                                    <>
                                                                                        <button
                                                                                            onClick={() => handleDocumentVerificationToggle(docId)}
                                                                                            disabled={agentState.updatingDocuments}
                                                                                            className="btn-verify-document"
                                                                                            title="Verify Document"
                                                                                        >
                                                                                            Verify
                                                                                        </button>
                                                                                        {!isVerified && (
                                                                                            <button
                                                                                                onClick={(e) => { e.stopPropagation(); handleRejectDocument(docId); }}
                                                                                                className="btn-reject-document"
                                                                                                disabled={agentState.updatingDocuments}
                                                                                                title="Reject Document"
                                                                                            >
                                                                                                Reject
                                                                                            </button>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <button
                                                                                        onClick={() => handleDocumentVerificationToggle(docId)}
                                                                                        disabled={agentState.updatingDocuments}
                                                                                        className="btn-reject-document"
                                                                                        title="Unverify Document"
                                                                                    >
                                                                                        Unverify
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                </div>

                                                                {/* Invalid Document Warning */}
                                                                {!isValidDocType && canEdit && (
                                                                    <div className="invalid-doc-warning">
                                                                        ⚠️ No valid document type found
                                                                    </div>
                                                                )}

                                                                {/* Rejected Reason */}
                                                                {isRejected && doc.rejectedReason && (
                                                                    <div className="document-reject-reason">
                                                                        <strong>Rejection Reason:</strong>
                                                                        {doc.rejectedReason}
                                                                    </div>
                                                                )}

                                                                {/* Document Links */}
                                                                <div className="document-links">
                                                                    {doc.frontSide && (
                                                                        <a
                                                                            href={doc.frontSide}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="doc-link"
                                                                        >
                                                                            📄 Front Side
                                                                        </a>
                                                                    )}
                                                                    {doc.backSide && (
                                                                        <a
                                                                            href={doc.backSide}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="doc-link"
                                                                        >
                                                                            📄 Back Side
                                                                        </a>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {interviews.length > 0 && (
                        <div className="agent-card" style={{ gridColumn: '1 / -1' }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '1.75rem',
                                borderBottom: '2px solid #f0f0f0'
                            }}>
                                <h3 className="card-title" style={{ padding: 0, margin: 0, borderBottom: 'none' }}>
                                    Interview History
                                </h3>
                                {interviews.length > 1 && (
                                    <button
                                        onClick={() => setShowAllInterviews(!showAllInterviews)}
                                        className="btn-toggle-interviews"
                                    >
                                        {showAllInterviews ? '▲ Show Less' : `▼ Show All (${interviews.length})`}
                                    </button>
                                )}
                            </div>
                            <div className="card-content">
                                <div className="interviews-grid">
                                    {(showAllInterviews ? interviews : interviews.slice(0, 1)).map((interview, index) => (
                                        <div key={interview._id || index} className="interview-item-card">
                                            <div className="interview-header">
                                                <div className="interview-id">
                                                    <span className="id-label">ID:</span>
                                                    <span className="id-value">{interview.interview_id}</span>
                                                </div>
                                                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                                                    <span className={`interview-status-badge ${getInterviewStatusClass(interview.status)}`}>
                                                        {ToFirstCapital(interview.status)}
                                                    </span>
                                                    {(interview.status === 'requested' || interview.status === 'scheduled') && canEdit && (
                                                        <button
                                                            onClick={() => handleOpenStatusModal(interview)}
                                                            className="btn-edit-status"
                                                            title="Update Status"
                                                        >
                                                            ✏️
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="interview-details">
                                                <div className="detail-row">
                                                    <span className="detail-label">Date</span>
                                                    <span className="detail-value">{formatDate(interview.meeting_date)}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <span className="detail-label">Time Slot</span>
                                                    <span className="detail-value">{formatTimeSlot(interview)}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <span className="detail-label">Timezone</span>
                                                    <span className="detail-value">{interview.timezone || "Asia/Kolkata"}</span>
                                                </div>
                                                {interview.status === 'cancelled' && interview.reject_reason ? (
                                                    <div className="detail-row">
                                                        <span className="detail-label">Cancellation Reason</span>
                                                        <span className="detail-value" style={{ color: '#dc2626', fontWeight: '600' }}>
                                                            {interview.reject_reason}
                                                        </span>
                                                    </div>
                                                ) : interview.status !== 'completed' && interview.meeting_link ? (
                                                    <div className="detail-row">
                                                        <span className="detail-label">Meeting Link</span>
                                                        <a href={interview.meeting_link} target="_blank" rel="noopener noreferrer" className="meeting-link">
                                                            Join Meeting
                                                        </a>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showConfirm && (
                <div className="modal-overlay" onClick={() => setShowConfirm(false)}>
                    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Confirm Status Change</h3>
                        </div>
                        <div className="modal-body">
                            <p>
                                Change account status to{" "}
                                <strong style={{ color: getStatusColor(selectedStatus) }}>
                                    {ToFirstCapital(selectedStatus)}
                                </strong>?
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                onClick={() => setShowConfirm(false)}
                                disabled={isUpdating}
                                className="btn-cancel"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={confirmStatusChange}
                                disabled={isUpdating}
                                className="btn-confirm"
                            >
                                {isUpdating ? "Updating..." : "Confirm"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showStatusModal && (
                <div className="modal-overlay" onClick={() => setShowStatusModal(false)}>
                    <div className="modal-box modal-box-large" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Update Interview Status</h3>
                        </div>
                        <div className="modal-body">
                            <div style={{ marginBottom: '1.5rem' }}>
                                <p style={{ marginBottom: '1rem', fontWeight: '600', color: '#1f2937' }}>
                                    Interview ID: <strong>{selectedInterview?.interview_id}</strong>
                                </p>

                                <label className="status-label" style={{ color: '#4b5563', marginBottom: '0.5rem', display: 'block' }}>
                                    Select New Status
                                </label>
                                <select
                                    value={newInterviewStatus}
                                    onChange={(e) => setNewInterviewStatus(e.target.value)}
                                    className="status-select-new"
                                    style={{ width: '100%' }}
                                >
                                    <option value="">Select Status</option>
                                    <option value="completed">Completed</option>
                                    <option value="scheduled">Scheduled</option>
                                    <option value="cancelled">Cancelled</option>
                                </select>

                                {/* Cancel reason field - only show when cancelled is selected */}
                                {newInterviewStatus === 'cancelled' && (
                                    <div className="form-group" style={{ marginTop: '1rem' }}>
                                        <label className="status-label" style={{ color: '#4b5563', marginBottom: '0.5rem', display: 'block' }}>
                                            Cancellation Reason
                                        </label>
                                        <textarea
                                            value={cancelReason}
                                            onChange={(e) => setCancelReason(e.target.value)}
                                            placeholder="Enter reason for cancellation..."
                                            rows={3}
                                            className="reject-reason-textarea"
                                            style={{
                                                width: '100%',
                                                padding: '0.75rem',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '0.375rem',
                                                fontSize: '0.875rem',
                                                resize: 'vertical',
                                                fontFamily: 'inherit'
                                            }}
                                        />
                                    </div>
                                )}

                                {/* Reschedule fields - only show when rescheduled is selected */}
                                {newInterviewStatus === 'scheduled' && (
                                    <div className="reschedule-fields" style={{ marginTop: '1rem' }}>
                                        <div className="form-group">
                                            <label className="status-label" style={{ color: '#4b5563', marginBottom: '0.5rem', display: 'block' }}>
                                                Meeting Date
                                            </label>
                                            <input
                                                type="date"
                                                value={meetingDate}
                                                onChange={(e) => setMeetingDate(e.target.value)}
                                                min={getTodayDate()}
                                                className="status-select-new"
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="status-label" style={{ color: '#4b5563', marginBottom: '0.5rem', display: 'block' }}>
                                                Time Slot
                                            </label>
                                            <select
                                                value={selectedSlot}
                                                onChange={(e) => setSelectedSlot(e.target.value)}
                                                className="status-select-new"
                                                style={{ width: '106%' }}
                                            >
                                                <option value="">Select Time Slot</option>
                                                {timeSlots.map(slot => (
                                                    <option key={slot.id} value={slot.id}>
                                                        {slot.time}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label className="status-label" style={{ color: '#4b5563', marginBottom: '0.5rem', display: 'block' }}>
                                                Meeting Link
                                            </label>
                                            <input
                                                type="url"
                                                value={meetingLink}
                                                onChange={(e) => setMeetingLink(e.target.value)}
                                                placeholder="https://meet.google.com/xxx-xxxx-xxx"
                                                className="status-select-new"
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="status-label" style={{ color: '#4b5563', marginBottom: '0.5rem', display: 'block' }}>
                                                Timezone
                                            </label>
                                            <select
                                                value={timezone}
                                                onChange={(e) => setTimezone(e.target.value)}
                                                className="status-select-new"
                                                style={{ width: '106%' }}
                                            >
                                                <option value="Asia/Kolkata">Asia/Kolkata (IST)</option>
                                                <option value="America/New_York">America/New_York (EST)</option>
                                                <option value="Europe/London">Europe/London (GMT)</option>
                                                <option value="Asia/Dubai">Asia/Dubai (GST)</option>
                                            </select>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                onClick={() => {
                                    setShowStatusModal(false);
                                    setSelectedInterview(null);
                                    setNewInterviewStatus('');
                                    setIsUpdatingInterview(false);
                                    setCancelReason('');
                                    resetRescheduleFields();
                                }}
                                disabled={isUpdatingInterview}
                                className="btn-cancel"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateInterviewStatus}
                                disabled={isUpdatingInterview ||
                                    (newInterviewStatus === 'cancelled' && !cancelReason?.trim()) ||
                                    (newInterviewStatus === 'scheduled' && (!meetingDate || !selectedSlot || !meetingLink))}
                                className="btn-confirm"
                            >
                                {isUpdatingInterview ? 'Updating...' : 'Update Status'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showRejectModal && (
                <div className="modal-overlay" onClick={() => setShowRejectModal(false)}>
                    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Reject Document</h3>
                        </div>
                        <div className="modal-body">
                            <p style={{ marginBottom: '1rem', color: '#4b5563' }}>
                                Please provide reason for rejecting document: <strong>{data.document_list?.find(doc =>
                                    (doc.id || doc._id) === selectedDocumentForReject)?.name}</strong>
                            </p>
                            <div className="form-group">
                                <label className="status-label" style={{ color: '#4b5563', marginBottom: '0.5rem', display: 'block' }}>
                                    Reject Reason *
                                </label>
                                <textarea
                                    value={rejectReason}
                                    onChange={(e) => setRejectReason(e.target.value)}
                                    placeholder="Enter reason for document rejection..."
                                    rows={4}
                                    className="reject-reason-textarea"
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '0.375rem',
                                        fontSize: '0.875rem',
                                        resize: 'vertical',
                                        fontFamily: 'inherit'
                                    }}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                onClick={() => {
                                    setShowRejectModal(false);
                                    setSelectedDocumentForReject(null);
                                    setRejectReason("");
                                }}
                                className="btn-cancel"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSaveDocumentVerifications}
                                disabled={!rejectReason?.trim()}
                                className="btn-confirm"
                                style={{
                                    opacity: rejectReason?.trim() ? 1 : 0.6,
                                    backgroundColor: rejectReason?.trim() ? '#ef4444' : '#f3f4f6'
                                }}
                            >
                                Reject Document
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewAgent;
